// Competências do seletor do Faturamento Total: da corrente até o 1º ciclo (jun/2026).
export const listaCompetencias = (corrente, inicio = '2026-06-01') => {
    const out = [];
    let ano = Number(String(corrente).slice(0, 4));
    let mes = Number(String(corrente).slice(5, 7));
    const fim = String(inicio).slice(0, 7);
    while (`${ano}-${String(mes).padStart(2, '0')}` >= fim) {
        out.push(`${ano}-${String(mes).padStart(2, '0')}`);
        mes -= 1;
        if (mes === 0) { mes = 12; ano -= 1; }
    }
    return out;
};
